import { useState, useEffect } from 'react';

interface OfoCodeItem {
  ofoCode: string;
  description: string;
  [key: string]: unknown;
}

export function useOfoChoices() {
  const [ofoCodesList, setOfoCodesList] = useState<OfoCodeItem[]>([]);
  useEffect(() => {
    fetch('/data/ofo-codes.json')
      .then(r => r.json())
      .then(data => setOfoCodesList(data))
      .catch(() => {});
  }, []);
  return ofoCodesList.map((o: OfoCodeItem) => ({
    id: o.ofoCode,
    name: `${o.ofoCode} - ${o.description}`,
  }));
}
